import React, { useState } from "react";

/**
 * TextArea component that provides a multi-line text input with debounced updates
 * Features character limit control and optimized update handling
 *
 * @param {Object} props - Component props
 * @param {Object} props.field - Field configuration object (currently unused but available for future extensions)
 * @param {Object} props.properties - Current form properties/values
 * @param {string} props.property - The property key this textarea manages
 * @param {number} props.maxLength - Maximum character limit (default: 1000)
 * @param {Function} props.updateProperties - Callback to update parent component properties
 */
const TextArea = ({
    field,
    properties,
    property,
    maxLength = 1000,
    updateProperties,
}) => {
    // State to store the typing timeout ID for debouncing
    const [typingTimeout, setTimingTimeout] = useState(0);

    /**
     * Handle textarea value changes with debouncing
     * Updates immediately for UI responsiveness, then waits 300ms before triggering parent update
     * Shorter delay than NumberInput due to text input being less intensive
     *
     * @param {Event} e - The textarea change event
     */
    function updateValue(e) {
        // Clone properties and update the specific property
        let props = { ...properties };
        props[property] = e.target.value;

        // Update immediately without triggering side effects (false parameter)
        updateProperties(props, false);

        // Clear existing timeout to restart debounce timer
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        // Set new timeout for delayed update with side effects (shorter delay for text)
        setTimingTimeout(
            setTimeout(() => {
                updateProperties(props); // Trigger full update after delay
            }, 300),
        );
    }

    return (
        <div className={"row forminput"}>
            <div className="col-sm-12 input-group">
                <textarea
                    className="form-control"
                    name={property}
                    onChange={updateValue}
                    maxLength={maxLength}
                    value={properties[property] || ""}
                />
            </div>
        </div>
    );
};

export default TextArea;
